import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { JsonLDService } from '../../services/json-ld.service';
import { jsonLdsToRemoveOnEveryPage } from '../../types/json-ls';

export const jsonLDDeactivateGuard: CanActivateFn = () => {
  const jsonLDService = inject(JsonLDService);
  jsonLdsToRemoveOnEveryPage.forEach(type => jsonLDService.remove(type));
  return true;
};
